<template>
  <searchable-grid title="Transactions" :fixed-height="fixedHeight" :column-defs="columnDefs"
    :get-rows-promise="getRows" @cellDoubleClicked="onCellDoubleClicked"></searchable-grid>
</template>

<script>
import api from '@/api';
import SearchableGrid from '@/components/grid/SearchableGrid.vue';
import { BoolFilter } from './BoolFilter';

export default {
  props: {
    forOfficeId: {
      type: Number,
      default: undefined,
    },
    fixedHeight: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      columnDefs: [
        {
          headerName: 'Account',
          field: 'typeName',
          cellRenderer: (params) => {
            if (params.value !== undefined) {
              return params.value;
            }
            return '<i class="el-icon-loading"></i>';
          },
        },
        {
          headerName: 'Action',
          field: 'action',
        },
        {
          headerName: 'Office',
          field: 'officeUserId',
        },
        {
          headerName: 'Client',
          field: 'clientName',
        },
        {
          headerName: 'User',
          field: 'userName',
        },
        {
          headerName: 'Amount',
          field: 'amount',
          filter: 'number',
        },
        {
          headerName: 'Void',
          field: 'void',
          valueFormatter(cell) {
            if (cell.value === undefined) return '';

            return cell.value ? 'Yes' : 'No';
          },
          filter: BoolFilter,
        },
        {
          headerName: 'Date',
          field: 'date',
          filter: 'date',
        },
      ],
    };
  },
  methods: {
    getRows(params) {
      const query = {};
      if (this.forOfficeId !== undefined) {
        query.officeId = this.forOfficeId;
      }
      return api.transaction.getGridData(params, query);
    },
    onCellDoubleClicked(event) {
      if (event.data && event.data.id) {
        this.$router.push({ name: 'transaction-detail', params: { transactionId: event.data.id } });
      }
    },
  },
  components: {
    SearchableGrid,
  },
};

</script>

<style lang="scss" scoped></style>
